import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=7c8b44f4&"
import script from "./Results.vue?vue&type=script&lang=ts&"
export * from "./Results.vue?vue&type=script&lang=ts&"
import style0 from "./Results.vue?vue&type=style&index=0&id=7c8b44f4&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports